import { WithdrawAction } from './action.model';

export class StaticTransactionsData {
    amount: string;
    fundistId: string;
    paymentButton: string;
    withdrawTo: string;
    childTransactions?: string[];
    parentTransactions?: string;

    constructor(actions: WithdrawAction[]) {
        const createdAction: WithdrawAction = actions.find(
            (action) => action.status === 'CREATED'
        );

        const createdMetadata: { [key: string]: string } =
            createdAction.metadata;

        this.amount = `${createdMetadata?.amount} ${createdMetadata?.currency}`;
        this.fundistId = createdAction?.externalWithdrawId;
        this.paymentButton = createdMetadata?.paymentSystem;

        let withdrawTo: string;
        if (
            createdMetadata?.withdrawAddress &&
            createdMetadata.withdrawAddress !== 'undefined'
        ) {
            withdrawTo = createdMetadata.withdrawAddress;
        } else if (
            createdMetadata?.iban &&
            createdMetadata.iban !== 'undefined'
        ) {
            withdrawTo = createdMetadata.iban;
        } else if (
            createdMetadata?.cardNumber &&
            createdMetadata.cardNumber !== 'undefined'
        ) {
            withdrawTo = createdMetadata.cardNumber;
        }

        if (withdrawTo) {
            this.withdrawTo = withdrawTo;
        }
        const splitAction: WithdrawAction = actions.find(
            (action) => action.status === 'SPLIT'
        );

        if (splitAction) {
            const children: string = splitAction.metadata.children;
            if (children) {
                this.childTransactions = Object.values(children);
            }
        }

        const parent: string = createdMetadata?.parent;

        if (parent) {
            this.parentTransactions = parent;
        }
    }
}
